import { useContext } from 'react';
import FieldName from '../utils/FieldName';
import NotSharedText from './NotSharedText';
import InviteUser from './InviteUsers';
import ParticipatingUsers from './ParticipatingUsers';
import RestrictedToPortfolioMode from '@/components/RestrictedToPortfolioMode';
import PortfolioMode from '@/lib/constants/PortfolioMode.enum';
import ChallengeContext from '../../../../../Challenge/ChallengeView/ChallengeContext';
import IsAnonymizedContext from '@/pages/PublicChallengePage/IsAnonymizedContext';
import AnonymizedParticipatingUsers from './AnonymizedParticipatingUsers';
import ControlsWrapper from './ControlsWrapper';
import LeaveChallenge from './LeaveChallenge';

// TODO better NotSharedText translation (coach mode/public version)
const ChallengeSharing = () => {
  const [challenge] = useContext(ChallengeContext);
  const isAnonymized = useContext(IsAnonymizedContext);

  const challengeIsShared = challenge.usersCount > 1;

  return (
    <section>
      <FieldName />
      {challengeIsShared && !isAnonymized && <ParticipatingUsers />}
      {challengeIsShared && isAnonymized && <AnonymizedParticipatingUsers />}
      {!challengeIsShared && <NotSharedText />}
      <RestrictedToPortfolioMode mode={PortfolioMode.STUDENT}>
        <ControlsWrapper>
          <InviteUser />
          {challengeIsShared && <LeaveChallenge />}
        </ControlsWrapper>
      </RestrictedToPortfolioMode>
    </section>
  );
};

export default ChallengeSharing;
